import React from 'react';
import Header from './Header';
import './AdminLayout.css';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className="admin-layout">
      <Header />
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
